import { BRAND_CODE } from "@/config/common";
import type { CustomProduct } from "@apptus/esales-api";
import { marketCode } from "@features/market/config/market-config";

export default function getVatRateFromProduct(
  product: CustomProduct,
  market: { code: string } | { countryCode: string },
) {
  if (!product.typedCustom?.numbers) return undefined;

  const identifier = `${BRAND_CODE}_${marketCode(market)}`;

  return product.typedCustom.numbers[`vat_${identifier}`];
}
